var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMusicNoteSimple = function SvgIconMusicNoteSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.287 2.792A1 1 0 0 0 11 3.75v9.627a4.75 4.75 0 1 0 2 3.873V5.094l6.213 1.864a1 1 0 1 0 .574-1.916zM11 17.25a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconMusicNoteSimple;